import { Routes } from "@angular/router";
import { WorkflowPartnerOneTariffOrderCancelComponent } from "./workflow-partner-one-tariff-order-cancel.component";

export const WorkflowPartnerOneTariffOrderCancelRouting: Routes = [
    {
        path: 'partner/change-tariff/:aid/order-cancel', component: WorkflowPartnerOneTariffOrderCancelComponent
    },
]
